import type { NextPage } from 'next';
import PageLoading from '~/components/common/PageLoading';

const Home: NextPage = () => {
  return <PageLoading />;
};

export default Home;
